module.exports = __webpack_public_path__ + "img/__icon_BUS_WINDA.04ab0c73.svg";